module.exports = __webpack_public_path__ + "img/1212040537.c3c017cd.jpg";